import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nProvider } from './i18n.js';
import { CardBackProvider } from './cardBacks.js';
import { SoundProvider } from './sound.js';
import { GameProvider } from './net/GameProvider.js';
import { App } from './components/App.js';
import { registerServiceWorker } from './registerServiceWorker.js';
import './index.css';

registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <I18nProvider>
      <SoundProvider>
        <CardBackProvider>
          <GameProvider>
            <App />
          </GameProvider>
        </CardBackProvider>
      </SoundProvider>
    </I18nProvider>
  </React.StrictMode>
);
